import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import _get from 'lodash/get';
import { Icon } from 'grab-ui';
import { generateOnelinkToInTransitScreen } from 'helper/deeplink';
import { isMultiStopDelivery } from 'helper/order';
import QRCodeContainer from 'components/v2/qrcode-container';
import ClickToSeeButton from 'components/v2/click-to-see-button';
import UnknownTaxiType from 'public/icons/delivery-option.svg';
import { ColumnWithIcon, ColumnWithPopover, InfoCard } from './common';
import styles from './common.less';

export const QRCode = ({ content }) => (
  <QRCodeContainer
    className={styles.qrCodeContainer}
    content={content}
    qrCodeClickable
  >
    <div
      className={content ? styles.qrCodeHelperText : styles.adminNotAccessible}
    >
      {content
        ? I18n.t(
            'phrase.common.express_anytime_booking_body_scan_qr_code_column',
          )
        : I18n.t(
            'phrase.common.express_anytime_booking_body_driver_contact_details_column',
          )}
    </div>
  </QRCodeContainer>
);

QRCode.propTypes = {
  content: PropTypes.string,
};

QRCode.defaultProps = {
  content: undefined,
};

const Driver = ({ driver, order, showInTransitQRCode }) => {
  if (!driver || !order) {
    return <span>{I18n.t('v2.orderTable.placeholder.noDriver')}</span>;
  }

  if (showInTransitQRCode) {
    const expressServiceID = _get(order, 'service.expressServiceID', 0);
    const bookingCode = isMultiStopDelivery(order)
      ? order.bookingCode
      : order.orderID;
    const deeplink = order.isCurrentUserDelivery
      ? generateOnelinkToInTransitScreen({ bookingCode, expressServiceID })
      : undefined;
    return (
      <ColumnWithPopover
        destroyTooltipOnHide
        popoverContent={
          <InfoCard
            primary={driver.name}
            secondary={_get(order, 'vehicle.plateNumber')}
            more={<QRCode content={deeplink} />}
          />
        }
      >
        <div>
          <ColumnWithIcon iconSrc={UnknownTaxiType}>
            {driver.name}
          </ColumnWithIcon>
        </div>
      </ColumnWithPopover>
    );
  }

  const phone = (
    <ClickToSeeButton
      hiddenElement={driver.phoneNumber || driver.phoneNumberCall}
      className={styles.clickToSeeButton}
      type={'primary'}
      ghost
    >
      <Icon type="phone" /> {I18n.t('v2.bookingsPage.clickToViewPhoneNumber')}
    </ClickToSeeButton>
  );

  return (
    <ColumnWithPopover
      destroyTooltipOnHide
      popoverContent={
        <InfoCard
          primary={driver.name}
          secondary={phone}
          tertiary={_get(order, 'vehicle.plateNumber')}
        />
      }
    >
      <div>
        <ColumnWithIcon iconSrc={UnknownTaxiType}>{driver.name}</ColumnWithIcon>
      </div>
    </ColumnWithPopover>
  );
};

Driver.defaultProps = {
  driver: undefined,
  order: undefined,
  showInTransitQRCode: false,
};

Driver.propTypes = {
  driver: PropTypes.shape({}),
  order: PropTypes.shape({}),
  showInTransitQRCode: PropTypes.bool,
};

export default Driver;
